<template>
  <div>
    <van-checkbox
      @click="changeClick"
      v-model="couponChecked"
      :name="coupon"
      checked-color="#F15100"
      icon-size="23px"
      label-disabled
    >
      <div class="title">
        <div class="coupon-title">优惠劵</div>
        <div class="card-name" v-if="payList.couponVos.length > 0 && useCoupon">
          <div v-if="deselection">
            <div v-if="defaultShow">
              已用推荐优惠，抵<span class="conpon-color">{{
                payList.reduction
              }}</span
              >元
            </div>
            <div v-if="resultArray.length >= 0 && !defaultShow">
              已选用{{ total }}张，抵<span class="conpon-color">{{
                payList.reduction
              }}</span
              >元
            </div>
          </div>
        </div>
      </div>
    </van-checkbox>
    <div class="shop-card">
      <van-popup
        @close="closed"
        v-model="show"
        round
        position="bottom"
        :style="{ height: '70%' }"
      >
        <div class="card-head">优惠劵</div>
        <div class="card-total">可用的劵</div>
        <div class="card-count">
          已选劵数量{{ total }}，共计抵扣
          <span class="card-money">￥{{ amount }}</span>
        </div>
        <coupon-cards
          v-if="payList.couponVos.length !== 0 && show"
          :payList="payList"
          @cardData="cardData"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import CouponCards from '@/components/content/couponCards'
export default {
  name: 'ChoiceCard',
  props: {
    payList: Object,
    useCoupon: Boolean,
  },
  data() {
    return {
      deselection: true,
      defaultShow: true,
      coupon: 'coupon',
      couponChecked: true,
      total: '',
      amount: '',
      show: false,
      resultArray: [],
    }
  },
  components: {
    CouponCards,
  },
  methods: {
    changeClick() {
      this.popupClick()
    },
    closed() {
      console.log('this.resultArr``````````ay', this.resultArray.length)
      if (this.resultArray.length == 0) {
        this.payList.cardItemName = ''
        this.couponChecked = false
        this.defaultShow = false
        this.deselection = false
        this.$emit('getCouponArray', this.resultArray)
      } else {
        this.defaultShow = false
        this.couponChecked = true
        this.deselection = true
        this.$emit('getCouponArray', this.resultArray)
      }
    },
    cardData(data) {
      console.log('data', data)
      this.total = data.cardTotal
      this.amount = data.cardMoney
      this.resultArray = data.result
      console.log('resultArray发射', this.resultArray)
      this.defaultShow = false
      if (data.cardsName.length > 0) {
        this.payList.cardItemName = ''
      }
    },
    popupClick() {
      if (!this.useCoupon) {
        this.$emit('againSelect', this.useCoupon)
        this.couponChecked = false
        this.defaultShow = false
        this.show = false
      } else {
        this.show = !this.show
        this.couponChecked = true
        this.defaultShow = false
      }
    },
  },
}
</script>

<style scoped lang="less">
/deep/.van-icon {
  color: white !important;
}
.title {
  width: 100%;
  font-size: 15px;
  color: #898989;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  .coupon-title {
    margin-right: 15px;
  }
}
.shop-card {
  font-size: 15px;

  .card-head {
    padding: 10px;
    text-align: center;
  }
  .card-total {
    text-align: center;
  }
  .card-count {
    color: #666;
    padding: 10px 0 0;
    .card-money {
      color: #cc0033;
    }
  }
}
.card-name {
  text-align: right;
  // width: 300rpx;
  overflow: hidden;
  text-overflow: ellipsis; //超出部分以省略号显示
}
.card-btn {
  margin-left: 10px;
  margin-bottom: 8px;
  font-size: 12px;
}
.conpon-color {
  color: #f15100;
}
</style>
